import React, { Component } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'

class Input extends Component {
  handleChange = (e) => {
    const { form, field } = this.props
    form.setFieldValue(field.name, e.target.value)
  }

  render() {
    const {
      form,
      field,
      label,
      type,
      multiline,
      rows,
      variant,
      className,
      placeholder,
      helperText,
      onChange,
      customError,
      disabled,
      readOnly,
    } = this.props

    const error = get(form.errors, field.name) || customError
    const fieldValue = get(form.values, field.name)
    const value = fieldValue !== null && fieldValue !== undefined ? fieldValue : ''
    
    // For outlined variant, use controlled input with explicit shrink control
    // This keeps the component controlled while ensuring label shrinks correctly
    const isOutlined = variant === 'outlined'
    const hasValue = value !== null && value !== undefined && String(value).trim() !== ''
    
    // Always provide InputLabelProps for outlined variant to control shrink
    const inputLabelProps = isOutlined ? { shrink: hasValue || undefined } : undefined

    // Add class to wrapper when value is present (for CSS targeting)
    const wrapperClassName = isOutlined && hasValue 
      ? `${className || ''} mui-input-has-value`.trim()
      : className

    return (
      <div className={wrapperClassName}>
        <FormControl fullWidth variant={variant}>
          <TextField
            inputProps={{
              autoComplete: 'new-field',
              form: {
                autocomplete: 'off',
              },
              // Read-only rather than disabled where the value must stay visible: a global
              // athena-one style hides the text of every `input[disabled]`.
              readOnly,
            }}
            label={label}
            placeholder={placeholder}
            type={type}
            variant={variant}
            multiline={multiline}
            rows={rows}
            value={value}
            InputLabelProps={inputLabelProps}
            fullWidth
            error={error}
            helperText={error || helperText || ''}
            onChange={onChange || this.handleChange}
            disabled={disabled}
          />
        </FormControl>
      </div>
    )
  }
}

Input.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  variant: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
}

export default Input
